import { Component } from 'react'
import axios from 'axios'
import { BASE_URL } from './../../constants/Common'
import { SERVER_IP } from './../../constants/Config'

class Authenticate extends Component {

    logout(redirectTo = BASE_URL) {
        axios.get(`${SERVER_IP}/logout?redirect=${redirectTo}`)
            .then(res => res.data)
            .then(url => {
                if (url) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('token_user')
                    localStorage.removeItem('user')
                    window.location.replace(url)
                }
            })

    }
}

const auth = new Authenticate()

export default auth



// WEBPACK FOOTER //
// ./src/components/Authentication/Authenticate.js